/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protein Translation (DNA / RNA → Protein) — Toolverse`)
};

const es_translate_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traducción de Proteínas (ADN / ARN → Proteína) — Toolverse`)
};

const de_translate_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteinübersetzung (DNA / RNA → Protein) — Toolverse`)
};

const nl_translate_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eiwitvertaling (DNA / RNA → Eiwit) — Toolverse`)
};

const fr_translate_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduction de protéines (ADN / ARN → Protéine) — Toolverse`)
};

const it_translate_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduzione proteica (DNA / RNA → proteina) — Toolverse`)
};

const pt_br2_translate_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradução de Proteínas (DNA / RNA → Proteína) — Toolverse`)
};

const pt_translate_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradução de Proteínas (ADN / ARN → Proteína) — Toolverse`)
};

const ja_translate_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タンパク質翻訳 (DNA / RNA → タンパク質) — Toolverse`)
};

const zh_translate_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`蛋白质翻译（DNA / RNA → 蛋白质）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_meta_title", locale)
	if (locale === "en") return en_translate_meta_title(inputs)
	if (locale === "es") return es_translate_meta_title(inputs)
	if (locale === "de") return de_translate_meta_title(inputs)
	if (locale === "nl") return nl_translate_meta_title(inputs)
	if (locale === "fr") return fr_translate_meta_title(inputs)
	if (locale === "it") return it_translate_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_translate_meta_title(inputs)
	if (locale === "pt") return pt_translate_meta_title(inputs)
	if (locale === "ja") return ja_translate_meta_title(inputs)
	return zh_translate_meta_title(inputs)
};